import {NgModule} from '@angular/core';
import {OtpComponent} from './otp.component';
import {OtpErrorComponent} from './error/error.component';
import {OtpSendComponent} from './send/send.component';
import {OtpVerifyComponent} from './verify/verify.component';
import {CommonModule} from '@angular/common';
import {OtpService} from './otp.service';
import {OtpSplitInputService} from './otp-split-input.service';
import {OtpSplitInputDirective} from './otp-split-input.directive';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {ParseOtpErrorMessagePipe, OtpRecipientDisplayPipe} from './otp-pipes.pipe';
import {OtpResendComponent} from './resend/resend.component';


@NgModule({
  declarations: [
    OtpComponent,
    OtpErrorComponent,
    OtpSendComponent,
    OtpResendComponent,
    OtpVerifyComponent,
    OtpSplitInputDirective,
    ParseOtpErrorMessagePipe,
    OtpRecipientDisplayPipe
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  exports: [
    OtpComponent,
    ParseOtpErrorMessagePipe,
    OtpSplitInputDirective,
    OtpRecipientDisplayPipe,
    OtpErrorComponent,
    OtpVerifyComponent,
    OtpResendComponent,
    OtpSendComponent
  ],
  providers: [
    OtpService,
    OtpSplitInputService
  ]
})

export class OtpModule {
}
